import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Avatar,
    Button,
    Divider,
    Tooltip,
    Paper,
    Hidden
} from "@material-ui/core";
import {
    Menu as MenuIcon,
    NotificationsNone,
    Fullscreen,
    Search,
    Cloud,
    Home,
    BarChart,
    AllInbox,
    AccountBalanceWallet,
    ShoppingCart,
    People,
    Person,
    Settings,
    Lock,
    Language,
    LocationOn,
    AccessTime,
    AccountBalance,
    PhoneAndroid,
    AccountBalanceOutlined,
    TrendingUp,
    ArrowForward,
    Assessment,
    GroupAdd,
    ReceiptLong,
    Refresh,
    Print,
    MoreVert,
    Receipt,
    Directions,
    MoveToInbox,
    Collections,
    AssignmentReturn,
    Dashboard,

} from "@material-ui/icons";
import "./PointSalse.css";
import { sto } from "../../../Context/InshData";
import { inshs, itmes } from "../../../Context/Local";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import SettingsIcon from "@material-ui/icons/Settings";
import { useTranslation } from "react-i18next";
import { DigitalClock } from "./TimeHour";
import { useHistory } from "react-router-dom";
import i18next from 'i18next';
import { t } from "i18next";
import { useRefresh } from "../../Settings/ReData";
import { styles, useStylesMain } from "../../../Fronts/Main/SwipeableNew";

const quickActions = [
    {
        title: "cust-account", subtitle: "إدارة بيانات العملاء",
        href: "HesabCustA", insh: inshs.Customers[2], isAllow: sto.used_Accnt_screen, icon: <GroupAdd />, tone: "purple"
    },
    // { title: "المشتريات", subtitle: "إدارة أوامر الشراء", icon: <ShoppingCart />, tone: "teal" },
    {
        title: "ext-receipt", subtitle: "ext-receipt", href: "ext-receipt", insh: "",
        isAllow: sto.used_Sqabd_screen, icon: <ShoppingCart />, tone: "gray"
    },
    {
        title: "str-inv-stat", subtitle: "متابعة الأصناف والمخزون",
        href: "ReportSafesJard", insh: "", isAllow: sto.used_Jarde_screen, icon: <ShoppingCart />, tone: "blue"
    },
    {
        title: "basic-product-data", subtitle: " شاشة الاصناف", href: "products", insh: itmes,
        isAllow: sto.used_Items_screen, icon: <Assessment />, tone: "orange"
    },
    {
        title: "sale-invoice", subtitle: "إجراء عمليات البيع", insh: inshs.Sales.sal, href: "Invoices",
        isAllow: sto.used_Nsale_screen, icon: <ShoppingCart />, tone: "green"
    },
    { title: "الإعدادات", subtitle: "ضبط النظام", href: "settings", isAllow: true, icon: <Settings />, tone: "violet" }
];

function TrendLine({ points, tone }) {
    return (
        <svg className={`trend-line trend-${tone}`} viewBox="0 0 150 52" aria-hidden="true">
            <polygon points={`0,52 ${points} 145,52`} className="trend-fill" />
            <polyline points={points} className="trend-stroke" />
            <circle cx="145" cy="6" r="3.5" className="trend-dot" />
        </svg>
    );
}
const pages = [
    {
        title: "sale-invoice",
        href: "Invoices",
        icon: <LocalMallIcon />,
        insh: inshs.Sales.sal,
        isAllow: sto.used_Nsale_screen,
    },
    {
        title: "sale-billet",
        href: "Invoices",
        icon: <AssignmentReturn />,
        insh: inshs.Sales.salRet,
        isAllow: sto.used_Rsale_screen,
    },
    {
        title: "basic-product-data",
        href: "products",
        icon: <Collections />,
        insh: itmes,
        isAllow: sto.used_Items_screen,
    },
    {
        title: "daily-rpt",
        href: "ReporteveryDay",
        icon: <Assessment />,
        insh: "",
        isAllow: sto.used_Dialy_screen,
    },
    {
        title: "close_shifts_report",
        href: "Shifts",
        icon: <Assessment />,
        insh: "",
        isAllow: sto.used_shifts_transClose ?? sto.used_Dialy_screen
    },
    {
        title: "cust-account",
        href: "HesabCustA",
        icon: <Assessment />,
        insh: inshs.Customers[2],
        isAllow: sto.used_Accnt_screen,
    },
    {
        title: "str-inv-stat",
        href: "ReportSafesJard",
        icon: <Assessment />,
        insh: "",
        isAllow: sto.used_Jarde_screen,
    },
    {
        title: "ext-receipt",
        href: "ext-receipt",
        icon: <MoveToInbox />,
        insh: "",
        isAllow: sto.used_Sqabd_screen,
    },
    {
        title: "ext-exchange",
        href: "ext-exchange",
        icon: <Directions />,
        insh: "",
        isAllow: sto.used_SSarf_screen,
    },
    {
        title: "int-exchange",
        href: "int-exchange",
        icon: <Directions />,
        insh: "",
        isAllow: sto.used_SSarf_screen,
    },
    {
        title: "purchase-invoice",
        href: "Invoices",
        icon: <LocalMallIcon />,
        insh: inshs.Purches.purch,
        isAllow: sto.used_purch_screen,

    },
    {
        title: "return-purchase",
        href: "Invoices",
        icon: <Collections />,
        insh: inshs.Purches.purchRet,
        isAllow: sto.used_Rpurch_screen,

    },
    {
        title: "invoice-price",
        href: "Invoices",
        icon: <Receipt />,
        insh: inshs.Sales.salViw,

        isAllow: sto.used_Nsale_screen,
    },
    {
        title: "str-twreed",
        href: "store-supp",
        icon: <Receipt />,
        insh: "",
        isAllow: sto?.used_twreed_makhzni_screen ?? false,
    },
    {
        title: "str-srf",
        href: "store-exch",
        icon: <Receipt />,
        insh: "",
        isAllow: sto?.used_sarfe_mkhzni_screen ?? false,
    },
    {
        title: "str-adjustment",
        href: "reStore",
        icon: <Receipt />,
        insh: "",
        isAllow: sto?.used_tasweay_mkhzni_screen ?? false,
    },
    {
        title: "str-receipt",
        href: "ReceiveST",
        icon: <Receipt />,
        insh: "",
        isAllow: sto?.used_estlam_mkhzni_screen ?? false,
    },
    {
        title: "str-item-trans",
        href: "curr-details-rpt",
        icon: <Receipt />,
        insh: "",
        isAllow: sto?.used_Treas_screen ?? false,
    },
    {
        title: "Settings",
        href: "settings",
        icon: <SettingsIcon />,
        isAllow: true,
    },

];




function QuickAction({ item, onClick }) {
    return (
        <button className="quick-action" onClick={() => onClick && onClick(item.title)} type="button">
            <Avatar className={`quick-icon quick-${item.tone}`}>{item.icon}</Avatar>
            <strong>{t(item.title)}</strong>
            <span>{item.subtitle}</span>
            <i className={`quick-arrow quick-${item.tone}`}><ArrowForward /></i>
        </button>
    );
}

export default function PointSalse(props) {
    const { isZeroDashboard, AutoOptions, found } = props;


    const { t } = useTranslation();
    const { t: transForm } = useTranslation(["forms"]);

    const totalss = AutoOptions?.totals;

    let i = {
        cash: Number(totalss?.totRsedStok),
        net: Number(totalss?.totRsedNetW),
        bank: Number(totalss?.totBanks),
        count: Number(AutoOptions?.dailySales[0]?.counts),
        sal: Number(AutoOptions?.dailySales[0]?.total),
        ret: Number(AutoOptions?.dailySales[1]?.total),
        sand: Number(AutoOptions?.dailySales[7]?.total),
        purch: Number(AutoOptions?.dailySales[3]?.total),
    }
    let eradAmount = parseFloat(i.cash + i.net + i.bank)?.toFixed(2);
    let countSal = parseFloat(i.count)?.toFixed(2);
    let safiSales = parseFloat(i.sal - i.ret)?.toFixed(2);
    let sandTot = parseFloat(i.sand)?.toFixed(2);
    let purchTot = parseFloat(i.sand)?.toFixed(2);
    // let pScr = getLS("premiScr", {});
    const StatCard = ({ item }) => {
        return (
            <section className={`stat-card stat-${item.tone}`}>
                <div className="stat-icon">{item.icon}</div>
                <div className="stat-copy">
                    <div className="stat-title">{transForm(item.title)}</div>
                    <div className="stat-value">{item.value}</div>
                    <div className="stat-unit">{item.unit}</div>
                    <div className="stat-change">
                        <span>{item.change}</span>
                        <TrendingUp />
                    </div>
                </div>
                <TrendLine points={item.points} tone={item.tone} />
            </section>
        );
    }
    const BalanceCard = ({ item }) => {
        return (
            <section className={`balance-card balance-${item.tone}`}>
                <Avatar className="balance-icon">{item.icon}</Avatar>
                <div className="balance-copy">
                    <div className="balance-title">{transForm(item.title)}</div>
                    <div className="balance-value">{item.value}</div>
                    <div className="balance-unit">ريال</div>
                </div>
            </section>
        );
    }
    const mainStats = [
        {
            title: "total-revenue",
            value: isZeroDashboard ? 0 : eradAmount ?? 0,
            unit: "ريال",
            tone: "purple",
            icon: <BarChart />,
            change: "+12% من أمس",
            points: "0,44 24,34 42,43 62,27 81,35 101,17 120,23 145,6"
        },
        {
            title: "sales-operations",
            value: isZeroDashboard ? 0 : countSal ?? 0,
            unit: "عملية",
            tone: "green",
            icon: <People />,
            change: "منذ آخر شهر",
            points: "0,44 24,34 42,43 62,27 81,35 101,17 120,23 145,6"
        },
        {
            title: "today-sales",
            value: isZeroDashboard ? 0 : safiSales ?? 0,
            unit: "ريال",
            tone: "pink",
            icon: <ShoppingCart />,
            change: "+8% من أمس",
            points: "0,44 24,34 42,43 62,27 81,35 101,17 120,23 145,6"
        }
    ];

    const balances = [
        { title: "fund_balance_for_period", value: !isZeroDashboard ? (AutoOptions?.totals?.totRsedStok ?? 0).toFixed(2) : 0, icon: <AllInbox />, tone: "blue" },
        { title: "bank_balance", value: !isZeroDashboard ? (AutoOptions?.totals?.totBanks ?? 0).toFixed(2) : 0, icon: <AccountBalance />, tone: "purple" },
        { title: "network_balance", value: !isZeroDashboard ? (AutoOptions?.totals?.totRsedNetW ?? 0).toFixed(2) : 0, icon: <AccountBalanceOutlined />, tone: "sky" },
        { title: "foward_balance", value: !isZeroDashboard ? (AutoOptions?.totals?.totAgels ?? 0).toFixed(2) : 0, icon: <AccountBalance />, tone: "mint" },
        { title: "إجمالي  قبض خارجي", value: isZeroDashboard ? 0 : sandTot ?? 0, icon: <TrendingUp />, tone: "teal" },
        { title: "إجمالي شراء", value: isZeroDashboard ? 0 : purchTot ?? 0, icon: <PhoneAndroid />, tone: "orange" },
    ];

    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [activeMenu, setActiveMenu] = React.useState("الرئيسية");
    const [language, setLanguage] = React.useState("العربية");

    const his = useHistory();

    const changeLanguage = () => {
        setLanguage(language === "العربية" ? "English" : "العربية");
        i18next.changeLanguage(language === "العربية" ? "en-US" : "ar");
    };
    const { fetch, fetching, isError } = useRefresh();

    const locConn = JSON.parse(localStorage.getItem("infoConn")) || {};

    const inshState = {
        server: locConn.server,
        ipinsh: locConn.ipinsh,
        changip: locConn.changip,
        ip: locConn.ip,
        endDigtip: locConn.endDigtip,
        namedb: locConn.namedb,
        id: locConn.id,
        pass: locConn.pass,
        useUri: locConn.useUri,
        port: locConn.port,
        ftp: locConn.ftp,
        typeConnct: locConn.typeConnct,
        mode: locConn.mode,
        leavle: "signIn",
    };

    const refDatas_out = () => {
        localStorage.removeItem("dataShamel");
        let loc = JSON.parse(localStorage.getItem("premiApp"));

        localStorage.setItem("premiApp", JSON.stringify({ ...loc, id: 0 }));
        localStorage.removeItem("DataRem");
    };
    const singout = () => {
        refDatas_out();
        localStorage.setItem("infoConn", JSON.stringify(inshState));
        refreshPage();
    };
    function refreshPage() {
        his.push({ pathname: "/" });
        window.location.reload(false);
    }
    const classes = useStylesMain();

    return (
        <div className="orax-dashboard" dir="ltr">
            <AppBar position="fixed" elevation={0} className="top-appbar" style={{ direction: "ltr" }}>
                <Toolbar className="top-toolbar">
                    <div className="top-brand">OraxCloud</div>
                    <div className="top-actions">

                        <Tooltip title="الإشعارات">
                            <IconButton aria-label="الإشعارات" className="notification-button"><NotificationsNone /><span className="notification-dot">3</span></IconButton>
                        </Tooltip>
                        <Tooltip title="ملء الشاشة">
                            <IconButton aria-label="ملء الشاشة" onClick={() => {
                                if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
                                    document.documentElement.requestFullscreen();
                                } else if (document.exitFullscreen) {
                                    document.exitFullscreen();
                                }
                            }}><Fullscreen /></IconButton>
                        </Tooltip>

                    </div>
                    <div className="top-cloud"><Cloud /></div>
                    <div className="top-actions">
                        <Tooltip title="القائمة">
                            <IconButton aria-label="فتح القائمة" onClick={() => setDrawerOpen(true)}><MenuIcon /></IconButton>
                        </Tooltip>
                    </div>
                </Toolbar>
            </AppBar>

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                classes={{ paper: "mobile-drawer" }}
            >
                <div className="drawer-brand">
                    <div className="company-logo">
                        <div className={classes.img}>
                            <Paper style={styles.paperContainer}> </Paper>
                        </div>
                        <b>OraxSoft</b>
                        <small>ERP CLOUD</small>
                    </div>
                </div>
                <List className="drawer-list">
                    {pages.filter?.((x) => x.isAllow).map((item) => (
                        <ListItem
                            button
                            key={item.title}
                            className={activeMenu === item.label ? "nav-item nav-active" : "nav-item"}
                            onClick={() => {
                                his.push({
                                    pathname: `/${item.href}`,
                                    state: item?.insh,
                                });
                            }}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={t(item.title)} />
                        </ListItem>
                    ))}
                </List>
                <div className="drawer-bottom">
                    <Button fullWidth className="logout-button" startIcon={<Lock />}
                     onClick={() => {
                        if (
                            window.confirm(
                                t("confirm-logout")
                            )
                        ) {
                            singout();
                        }
                    }}>{transForm("logout")}</Button>
                    <Button fullWidth className="language-button" startIcon={<Language />}
                        onClick={() => changeLanguage()}>
                        {language}
                    </Button>
                </div>
            </Drawer>

            <main className="dashboard-main">

                <header className="welcome-banner">
                    <Hidden smDown>
                        <div className="banner-visual" >
                            <div className="pos-device">
                                <div className="pos-screen"><span>ORAX</span><div /><div /><div /></div>
                                <div className="pos-base" />
                                <div className="pos-scanner" />
                            </div>
                            <div className="banner-caption">
                                <strong>إدارة أسهل .. مبيعات أكثر</strong>
                                <span>نظام نقاط البيع من أوراكس سوفت</span>
                                <i />
                            </div>
                        </div>
                    </Hidden>

                    <div className="company-info" >
                        <div className="company-logo">
                            <div className={classes.img}>
                                <Paper style={styles.paperContainer}> </Paper>
                            </div>
                            <b>OraxSoft</b>
                            <small>ERP CLOUD</small>
                        </div>
                        <h1>{found?.nameA}</h1>
                        <p><LocationOn />{sto?.branchNames}</p>
                        <p><Person />{sto?.usernames}</p>
                    </div>
                    <div className="banner-tools">
                        <Tooltip title="تحديث"><IconButton onClick={() => fetch()}><Refresh /></IconButton></Tooltip>
                        <Tooltip title="خيارات"><IconButton onClick={() => setDrawerOpen(true)}><MoreVert /></IconButton></Tooltip>
                    </div>
                </header>

                <div className="dashboard-content">
                    <div className="stats-grid">
                        {mainStats.slice().reverse().map((item) => <StatCard key={item.title} item={item} />)}
                    </div>

                    <section className="balance-strip">
                        <div className="date-widget">
                            {DigitalClock()}
                        </div>
                        {balances.map((item) => <BalanceCard key={item.title} item={item} />)}
                    </section>

                    <section className="quick-section">
                        <div className="section-heading">
                            <h2>الخيارات السريعة</h2>
                            <span><TrendingUp /></span>
                        </div>
                        <div className="quick-grid">
                            {quickActions.slice().reverse().map((item) => (
                                <QuickAction key={item.title} item={item}
                                    onClick={() => {
                                        if (item.isAllow) {
                                            his.push({
                                                pathname: `/${item.href}`,
                                                state: item?.insh,
                                            });
                                        }

                                    }} />
                            ))}
                        </div>
                    </section>
                </div>
                <footer className="dashboard-footer">OraxCloud <span>•</span> نظام أوراكس السحابي لإدارة الأعمال</footer>
            </main>

            <aside className="desktop-sidebar">
                <div className="sidebar-company">
                    <div className="company-logo">
                        <div className={classes.img}>
                            <Paper style={styles.paperContainer}> </Paper>
                        </div>
                        <b>OraxSoft</b>
                        <small>ERP CLOUD</small>
                    </div>
                </div>
                <Divider />
                <List className="sidebar-nav">
                    {pages.filter?.((x) => x.isAllow).map((item) => (
                        <ListItem button key={item.label}
                            className={activeMenu === item.label ? "nav-item nav-active" : "nav-item"}
                            onClick={() => {
                                his.push({
                                    pathname: `/${item.href}`,
                                    state: item?.insh,
                                });
                            }}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={t(item.title)} />
                            <span className="nav-chevron">‹</span>
                        </ListItem>
                    ))}
                </List>
                <div className="sidebar-bottom">
                    <Button fullWidth className="logout-button" startIcon={<Lock />}
                        onClick={() => {
                            if (
                                window.confirm(
                                    t("confirm-logout")
                                )
                            ) {
                                singout();
                            }
                        }}>{transForm("logout")}</Button>
                    <Button fullWidth className="language-button" startIcon={<Language />}
                        onClick={() => changeLanguage()}>
                        {language}
                    </Button>
                </div>
            </aside>
        </div>
    );
};

